import { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ScreenIn } from './screenInFactory'
import { LifeCycle } from '@wix/thunderbolt-symbols'

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler).to(ScreenIn)
	bind(LifeCycle.PageWillUnmountHandler).to(ScreenIn)
}
